import React from "react";
import PublicLayout from "../../layout/publicLayOut";
import ContactDetails from "../ContactDetailsPage/ContactDetails";
import { getBrandBasePath } from "../routes/pathUtils";

const EntrepreneurContactUs = () => {
  const isLoggedIn = !!sessionStorage.getItem("ssoToken");
  const brandBasePath = getBrandBasePath(window.location.pathname);

  return (
    <PublicLayout redirectTo={brandBasePath}>
      <main className="w-full min-h-full p-0 m-0">
        <div id="main_section" className="w-full min-h-full">
          <ContactDetails isUserLogged={isLoggedIn} />
        </div>
      </main>
    </PublicLayout>
  );
};

export default EntrepreneurContactUs;
